import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  TemplateRef,
} from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
interface FormControlOption {
  value: string;
  label: string;
  suffix?: { title: string };
}

@Component({
  selector: 'pr-checkbox-group',
  templateUrl: './pr-checkbox-group.component.html',
  styleUrls: ['./pr-checkbox-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: PrCheckboxGroupComponent,
      multi: true,
    },
  ],
  standalone: false,
})
export class PrCheckboxGroupComponent implements ControlValueAccessor {
  _model: any;
  onChange: any = value => {};
  onTouch: any = () => {};
  @Input() formControlName: string;
  @Input() template: TemplateRef<any>;
  @Input() options: FormControlOption[] = [];
  @Input() maxSelected = null;
  @Input() asToggle = false;
  @Input() derrors = false;
  @Input() isDefault = true;
  @Input() loading = false;
  @Input() label = '';
  @Input() readonly = false;
  @Input() required: boolean = false;
  @Input() detectChangesOnWrite: boolean = false;

  get model() {
    return this._model;
  }

  selectedItems: any = null;
  changeLog: string[] = [];
  constructor(
    private controlContainer: ControlContainer,
    private cdr: ChangeDetectorRef,
  ) {}
  get control() {
    return this.controlContainer.control.get(this.formControlName);
  }
  ngOnInit() {
    if (this.control) this._model = this.control.value;
  }

  writeValue(value: any): void {
    this._model = value;
    if (this.detectChangesOnWrite && this.cdr) {
      this.cdr.markForCheck();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  set(value: any) {
    this._model = value;
    this.onChange(this._model);
  }
  isDisabled(value) {
    return this._model?.length >= this.maxSelected && !this.contains(value);
  }
  containsMoreThanMaxSelected() {
    return this._model?.length >= this.maxSelected;
  }
  addOrRemove(value: any) {
    if (this.contains(value)) {
      this.remove(value);
    } else {
      if (this.maxSelected && this.containsMoreThanMaxSelected()) {
        return;
      }
      this.add(value);
    }
  }

  contains(value: any): boolean {
    if (this._model instanceof Array) {
      return this._model.indexOf(value) > -1;
    } else if (!!this._model) {
      return this._model === value;
    }

    return false;
  }

  add(value: any) {
    if (!this.contains(value)) {
      if (this._model instanceof Array) {
        this.isToggled();
        this._model.push(value);
      } else {
        this._model = [value];
      }
      this.onChange(this._model);
    }
  }
  isToggled() {
    if (this.asToggle) {
      this._model = [];
    }
  }

  remove(value: any) {
    const index = this._model.indexOf(value);
    if (!this._model || index < 0) {
      return;
    }

    this._model.splice(index, 1);
    this.onChange(this._model);
  }
  onItemChange(event, value) {
    this.changeLog.push('item changed, value is: ' + value);
  }
  conditinallyDisblayTemplate2(item) {
    return this._model && this._model.length > 0 && this._model.includes(item);
  }
}
